import { generateSeed } from '@utils/generateSeed';
import Constants from '../../../../constants/best_of_weddings';
import { SearchConstants } from '../../../../settings';
import { fetchBase } from '../../../actions/search';
import { awardsInfo } from '../../../utils/awardsInfo';

export function fetchVendors(
	category,
	location,
	awardType,
	anonymousId,
	userId,
) {
	const { bow } = awardsInfo();
	const filters =
		awardType.slug === bow.slug
			? [SearchConstants.BOW_CURRENT_WINNER_ID, category.id]
			: [SearchConstants.BOW_HALL_OF_FAME_ID, category.id];

	const options = {
		categoryGuid: category.id,
		location,
		filters,
		page: 1,
		sort: 'featured',
		seed: generateSeed(),
		member: {
			anonymousId,
			userId,
		},
	};

	return fetchBase(Constants.FETCH_VENDORS, options);
}

export function setCategory(category) {
	return {
		type: Constants.CHANGED_CATEGORY,
		category,
	};
}

export function setLocation(location) {
	const { city, stateCode, market } = location;
	return {
		type: Constants.CHANGED_LOCATION,
		location: { city, stateCode, market },
	};
}

export function setAwardType(awardType) {
	return {
		type: Constants.CHANGED_AWARD_TYPE,
		awardType,
	};
}
